import { css } from 'styled-components';

export default css`
  /* width */
  ::-webkit-scrollbar {
    width: 9px;
    height: 9px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #B2B2B2;
    border-radius: 4px;
  }
`;
